export enum ButtonType {
  Switch = 'switch',
  Checkbox = 'checkbox'
}